import moment from 'moment';
import fileDownload from 'react-file-download';
import { showToast } from 'stores/ToastStore';
import qs from 'querystring';
import client from './rest/AdminClient';
import { getBearerGrantTypeAuthHeaders } from '../helpers/auth_helpers';
import ACIZonesActionCreators from '../actions/ACIZonesActionCreators';
const MALAA_URL_PATH = MALAA_URL + '/api/reporting';
const getBaseHeaders = () => {
    return {
        'Content-Type': 'application/json',
        Authorization: getBearerGrantTypeAuthHeaders(),
    };
};
const getFetchController = () => {
    return new AbortController();
};
const getFetchRequest = (url, options) => {
    return { response: fetch(url, options) };
};
const getShipmentsByStream = (body, controller) => {
    const { params } = body;
    Object.keys(params).forEach((item) => {
        const { filterType } = params[item];
        if (filterType === 'date') {
            const { dateTo, dateFrom } = params[item];
            if (dateTo !== null) {
                params[item].dateTo = moment(dateTo).endOf('day').toISOString();
            }
            if (dateFrom) {
                params[item].dateFrom = moment(dateFrom).startOf('day').toISOString();
            }
        }
    });
    const reqOptions = {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    };
    if (controller && controller.signal) {
        reqOptions.signal = controller.signal;
    }
    const url = `${MALAA_URL_PATH}/stream`;
    return getFetchRequest(url, reqOptions);
};
const getShipmentsCount = (body) => {
    const reqOptions = {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    };
    const url = `${MALAA_URL_PATH}/count`;
    return fetch(url, reqOptions).then((response) => {
        return response.json();
    });
};
const getUVCsvExport = (body) => {
    const reqOptions = {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    };
    const url = `${MALAA_URL_PATH}/csv`;
    return fetch(url, reqOptions)
        .then((response) => response.blob())
        .then((blob) => {
        fileDownload(blob, 'export.csv');
    });
};
const getMetricScorecardCSVExport = (body) => {
    const reqOptions = {
        method: 'POST',
        mode: 'cors',
        headers: getBaseHeaders(),
        body: JSON.stringify(body),
    };
    const url = `${API_HOST}/api/v2/metrics/csv`;
    return getFetchRequest(url, reqOptions);
};
const getScheduledYardAppointmentsCSV = (query) => {
    const reqOptions = {
        method: 'POST',
        mode: 'cors',
        headers: getBaseHeaders(),
    };
    const url = `${API_HOST}/api/appointments/csv?${qs.stringify(Object.assign({}, query))}`;
    return getFetchRequest(url, reqOptions);
};
const getMetricScorecardCSVExportRowCount = async (data) => {
    return client({
        method: 'POST',
        path: `${API_HOST}/api/v2/metrics/csv/count`,
        entity: JSON.stringify(data),
    })
        .then((response) => {
        return response.entity;
    })
        .catch((e) => {
        showToast('Export Failed', `Export Failed: ${e.message}`, 'error');
        throw e;
    });
};
const getElasticSearchResults = (body) => {
    const reqOptions = {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'x-api-key': ES_API_KEY,
        },
        body: JSON.stringify(body),
    };
    return fetch(`${ES_HOST}/search`, reqOptions).then((response) => response.json());
};
const getForwardRegress = async (data) => {
    return client({
        method: 'POST',
        path: '/api/shipment/state/transitions',
        entity: JSON.stringify(data),
    })
        .then((result) => {
        const { progress, regress } = result.entity.transitions;
        return { progress, regress };
    })
        .catch((e) => {
        return e;
    });
};
const upsertACIZones = async (data) => {
    const URL = `${ACI_ZONES_URL}/mappings/zones/aci`;
    const reqOptions = {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    };
    const response = await fetch(URL, reqOptions);
    return response.json();
};
export default {
    getFetchController() {
        return getFetchController();
    },
    getForwardRegress(payload) {
        return getForwardRegress(payload);
    },
    getElasticSearchResults(payload) {
        return getElasticSearchResults(payload);
    },
    getShipmentsByStream(payload, controller) {
        return getShipmentsByStream(payload, controller);
    },
    getShipmentsCount(payload) {
        return getShipmentsCount(payload);
    },
    getUVCsvExport(payload) {
        return getUVCsvExport(payload);
    },
    getMetricScorecardCSVExport(payload) {
        return getMetricScorecardCSVExport(payload);
    },
    getMetricScorecardCSVExportRowCount(payload) {
        return getMetricScorecardCSVExportRowCount(payload);
    },
    getScheduledYardAppointmentsCSV(payload) {
        return getScheduledYardAppointmentsCSV(payload);
    },
    upsertACIZones(payload) {
        upsertACIZones(payload).then(() => ACIZonesActionCreators.upsertACIZonesSuccess(), (error) => ACIZonesActionCreators.upsertACIZonesFail(error));
    },
};
